if (!customElements.get("loyalty-total")) {
  customElements.define(
    "loyalty-total",
    class LoyaltyTotal extends HTMLElement {
      constructor() {
        super();
      }

      async connectedCallback() {
        this.points_el = this.querySelector(".points");

        if (!this.points_el) return;

        var product_date = [];
        this.quantity_data = {};
        try {
          product_date = JSON.parse(
            this.querySelector("#loyalty-cart-data").innerText,
          );

          this.quantity_data = JSON.parse(
            this.querySelector("#loyalty-quantity-data").innerText,
          );
        } catch (error) {
          console.error(error);
        }
        if (product_date.length == 0 || Object.keys(this.quantity_data) == 0)
          return;

        this.potentialPointCall(product_date).then((all_data) => {
          this.renderPoints(all_data);
        });
      }

      async potentialPointCall(products) {
        var promises = products.map((product) => {
          return fetch(
            "https://storefront.yotpo.com/loyalty/v3/stores/PoXGxVsm1TW57w4qSThgEdjI5WB0UHkZrJWGgUMy/product_potential_points",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(product),
            },
          )
            .then((data) => data.json())
            .then((data) => data)
            .catch((error) => {
              debugger;
            });
        });

        return Promise.all(promises);
      }

      renderPoints(all_data) {
        var sum = 0;
        for (let i = 0; i < all_data.length; i++) {
          const element =
            all_data[i].product_potential_points?.variants_with_points[0];

          if (!element) continue;

          sum = sum + element.points * this.quantity_data[element.id];
        }

        if (sum > 0) {
          this.points_el.innerText = sum;
        }
      }
    },
  );
}
